import type { ContactContent } from "./types";

export const contactContent: ContactContent = {
  heading: "Contact",
  intro:
    "Have a question, feedback, or just want to say hi? Send a message and we'll get back to you.",
  formLabels: {
    name: "Name",
    email: "Email",
    message: "Message",
    submit: "Send message",
    submitting: "Sending…",
  },
  successMessage:
    "Thanks — your message is on its way. We'll get back to you soon.",
  errorMessages: {
    rateLimited: "You've sent a few messages recently — try again in a bit.",
    server:
      "Something went wrong sending your message. Please try again — your message hasn't been lost.",
  },
  metaTitle: "Contact — Verderem",
  metaDescription:
    "Have a question or feedback about Verderem? Send us a message.",
};
